import Requester from "../helpers/Requester";
import App from "../layouts/app";
import { router } from "@inertiajs/react";
import TeamForm from "../components/TeamForm";
import ContentWrapper from "../components/ContentWrapper";
import PageTitle from "../components/PageTitle";

export default function TeamAdd() {

    const saveTeam = (data: any) => {
        const requester = new Requester();

        requester.post(requester.getUrl(`api/teams`), data).then((response) => {
            router.visit(`/admin/teams`);
        }).catch((error) => {
            alert("Error adding team: " + error.message);
        })
    }

    return (
        <App>
            <PageTitle title="Add Team" />
            <ContentWrapper>
                <TeamForm onSubmit={saveTeam} />
            </ContentWrapper>
        </App >
    )
}